/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Paragraph = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  padding: 8px;
  text-transform: none;
  text-align: left;
`;

export const IconWrap = styled.div`
  margin: 8px 0 0 8px;
  display: flex;
  align-items: center;
  align-self: flex-start;
`;

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 4px;
  svg {
    transform: rotate(180deg);
  }
  ${({ type }) => {
    if (type === 'information' || type === 'with_close_btn') {
      return css`
        color: ${Palette.PrimaryGray._700};
        background: ${Palette.PrimaryGray._000};
        svg {
          fill: ${Palette.PrimaryGray._400};
        }
      `;
    }
    if (type === 'warning') {
      return css`
        color: ${Palette.Orange._900};
        background: ${Palette.Orange._000};
        svg {
          fill: ${Palette.Orange._400};
        }
      `;
    }
    if (type === 'error') {
      return css`
        color: ${Palette.Red._900};
        background: ${Palette.Red._000};
        svg {
          fill: ${Palette.Red._400};
        }
      `;
    }
    if (type === 'success') {
      return css`
        color: ${Palette.Green._900};
        background: ${Palette.Green._000};
        svg {
          fill: ${Palette.Green._600};
        }
      `;
    }
  }}
`;

export const BtnWrap = styled.div`
  margin-left: auto;
  align-self: flex-start;
`;
